import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshanishiignapurcab() {



    const cardData = {





keyword: "Mumbai to Shani Shingnapur Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Shani Shingnapur Cab Service for devotees, families, and travelers planning a spiritual journey to one of Maharashtra's most famous pilgrimage destinations. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and peaceful travel experience. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup from Mumbai, flexible travel plans, and 24/7 customer support, we ensure a smooth and hassle-free pilgrimage trip. Whether you need a one-way cab, round trip taxi, family temple tour, or customized Maharashtra pilgrimage package, Shreesha Tours & Travels provides dependable transportation with complete comfort and convenience.",

topPlaces: [
  {
    title: "Shani Shingnapur Temple",
    description: "Shani Shingnapur is a famous pilgrimage village in Maharashtra dedicated to Lord Shani. The temple is known for its unique tradition of open-air worship and attracts thousands of devotees throughout the year."
  },
  {
    title: "Sai Baba Temple Shirdi",
    description: "Shirdi is one of Maharashtra's most popular pilgrimage destinations, famous for Sai Baba Temple, Dwarkamai, Chavadi, and spiritual attractions. Many travelers combine Shani Shingnapur and Shirdi in one cab tour."
  },
  {
    title: "Grishneshwar Jyotirlinga",
    description: "Grishneshwar Temple near Ellora is one of the twelve Jyotirlingas of Lord Shiva. It is an important religious destination often included in Maharashtra pilgrimage tours."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a UNESCO World Heritage Site famous for ancient rock-cut Buddhist, Hindu, and Jain caves. It is a must-visit attraction for history and architecture lovers."
  },
  {
    title: "Bibi Ka Maqbara Aurangabad",
    description: "Bibi Ka Maqbara is a historic monument known for its beautiful Mughal architecture and is often called the Taj Mahal of the Deccan."
  },
  {
    title: "Trimbakeshwar Temple Nashik",
    description: "Trimbakeshwar is one of the twelve Jyotirlingas and a major pilgrimage destination near Nashik. Devotees frequently visit this sacred temple along with other Maharashtra religious places."
  },
  {
    title: "Panchavati Nashik",
    description: "Panchavati is a famous religious area in Nashik associated with Lord Ram's exile period, featuring temples, ghats, and spiritual landmarks."
  },
  {
    title: "Bhimashankar Jyotirlinga",
    description: "Bhimashankar is one of the twelve Jyotirlingas surrounded by Sahyadri forests and natural beauty. It is a popular destination for devotees and nature lovers."
  },
  {
    title: "Muktidham Nashik",
    description: "Muktidham is a beautiful marble temple complex in Nashik featuring replicas of major Hindu temples and sacred sites. It is visited by pilgrims and tourists."
  },
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves are a UNESCO World Heritage Site known for ancient Buddhist paintings, sculptures, and remarkable historical significance. It is a popular addition to Maharashtra heritage tours."
  }
],




"services": [
  {
    "name": "Mumbai to Shani Shingnapur Cab",
    "description": "Book Mumbai to Shani Shingnapur Cab for a comfortable and reliable religious journey with professional chauffeurs and well-maintained AC vehicles. Enjoy a peaceful pilgrimage trip with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family darshan, temple visits, and spiritual tours."
  },
  {
    "name": "Mumbai to Shani Shingnapur Taxi",
    "description": "Choose Mumbai to Shani Shingnapur Taxi for safe and convenient temple travel with experienced drivers and comfortable vehicles. Get doorstep pickup, affordable fares, clean AC cars, and reliable taxi services for your Shani Dev Darshan journey."
  },
  {
    "name": "Mumbai to Shani Shingnapur Cab Service",
    "description": "Book Mumbai to Shani Shingnapur Cab Service for hassle-free pilgrimage transportation with trained chauffeurs and premium vehicles. Our cab services are ideal for religious tours, family trips, weekend visits, and spiritual journeys with comfortable travel arrangements."
  },
  {
    "name": "Mumbai to Shani Shingnapur Taxi Service",
    "description": "Hire Mumbai to Shani Shingnapur Taxi Service for a smooth and relaxing journey to the famous Shani Temple. Enjoy professional drivers, spacious cars, flexible booking options, and affordable travel packages for devotees and families."
  },
  {
    "name": "Mumbai to Shani Shingnapur Cab Booking",
    "description": "Complete Mumbai to Shani Shingnapur Cab Booking with easy reservations and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and enjoy a comfortable temple darshan journey."
  },
  {
    "name": "Mumbai to Shani Shingnapur Darshan Cab",
    "description": "Book Mumbai to Shani Shingnapur Darshan Cab for a convenient pilgrimage experience with dedicated vehicles and experienced chauffeurs. Travel comfortably for Shani Dev Darshan, temple visits, and religious tours with family and groups."
  },
  {
    "name": "Mumbai to Shani Shingnapur Tour Package",
    "description": "Choose Mumbai to Shani Shingnapur Tour Package by cab for a complete religious travel experience. Enjoy comfortable transportation, flexible schedules, and reliable cab services for temple visits, sightseeing, and spiritual journeys."
  },
  {
    "name": "Mumbai to Shani Shingnapur Car Rental",
    "description": "Select Mumbai to Shani Shingnapur Car Rental for chauffeur-driven vehicles designed for comfortable pilgrimage travel. Get spacious cars, professional drivers, and flexible rental options for family trips and religious tours."
  },
  {
    "name": "Mumbai to Shani Shingnapur One Way Cab",
    "description": "Book Mumbai to Shani Shingnapur One Way Cab for convenient drop taxi service without return charges. Enjoy comfortable travel with experienced drivers, clean vehicles, and flexible pickup options from Mumbai."
  },
  {
    "name": "Mumbai to Shani Shingnapur Round Trip Taxi",
    "description": "Reserve Mumbai to Shani Shingnapur Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Perfect for same-day darshan, family pilgrimage trips, and spiritual tours."
  },
  {
    "name": "Mumbai Religious Tour Cab",
    "description": "Choose Mumbai Religious Tour Cab for safe and comfortable temple journeys across Maharashtra. Travel with professional chauffeurs and premium vehicles for Shani Shingnapur, Jyotirlinga, and other religious destinations."
  },
  {
    "name": "Mumbai Temple Tour Taxi",
    "description": "Book Mumbai Temple Tour Taxi for convenient spiritual travel with reliable transportation and experienced drivers. Enjoy peaceful temple visits, family darshan trips, and customized religious tour packages."
  },
  {
    "name": "Mumbai to Shani Shingnapur Innova Cab",
    "description": "Choose Mumbai to Shani Shingnapur Innova Cab for spacious and comfortable pilgrimage travel. Ideal for families and groups with premium seating, extra luggage space, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Shani Shingnapur Ertiga Cab",
    "description": "Reserve Mumbai to Shani Shingnapur Ertiga Cab for affordable group travel with comfortable seating and reliable performance. Perfect for families and small groups planning a temple darshan trip."
  },
  {
    "name": "Best Mumbai Shani Shingnapur Cab Booking",
    "description": "Choose the Best Mumbai Shani Shingnapur Cab Booking service for safe, comfortable, and affordable pilgrimage travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and reliable cab services for Shani Dev Darshan with family and devotees."
  }
],
"tableData": [
  ["Mumbai to Shani Shingnapur Cab", "Mumbai to Shani Shingnapur Taxi"],
  ["Mumbai to Shani Shingnapur Cab Service", "Mumbai to Shani Shingnapur Taxi Service"],
  ["Mumbai to Shani Shingnapur Cab Booking", "Mumbai to Shani Shingnapur Darshan Cab"],
  ["Mumbai to Shani Shingnapur Tour Package", "Mumbai to Shani Shingnapur Car Rental"],
  ["Mumbai to Shani Shingnapur One Way Cab", "Mumbai to Shani Shingnapur Round Trip Taxi"],
  ["Mumbai Religious Tour Cab", "Mumbai Temple Tour Taxi"],
  ["Mumbai to Shani Shingnapur Innova Cab", "Mumbai to Shani Shingnapur Ertiga Cab"],
  ["Best Mumbai Shani Shingnapur Cab Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Shani Shingnapur Cab Service",
    WhyChoosedescription: "Shreesha Travels offers reliable Mumbai to Shani Shingnapur cab services for devotees, families, and travellers visiting the famous Shani temple. Enjoy a peaceful pilgrimage journey with comfortable vehicles, experienced drivers, and flexible travel options."
  },
  {
    WhyChooseheading: "Convenient Pilgrimage Travel from Mumbai",
    WhyChoosedescription: "Plan your spiritual trip from Mumbai to Shani Shingnapur with hassle-free cab booking. Our services are designed for temple visits, family tours, senior citizens, and customized religious travel plans."
  },
  {
    WhyChooseheading: "Suitable Cars for Small & Large Groups",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your group size and comfort requirements."
  },
  {
    WhyChooseheading: "Ideal for Devotees & Family Temple Tours",
    WhyChoosedescription: "Our Mumbai to Shani Shingnapur taxis provide comfortable transportation for devotees, family groups, senior citizens, and travellers combining nearby religious destinations."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "Book a direct one-way cab or choose a round-trip package with flexible return timing, waiting options, and customized travel plans according to your temple visit schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Maharashtra Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Maharashtra highways and pilgrimage routes, ensuring safe driving, timely service, and a smooth journey from Mumbai to Shani Shingnapur."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles for Pilgrimage Trips",
    WhyChoosedescription: "Every cab is properly maintained, sanitized, air-conditioned, and inspected before travel to provide a comfortable and relaxing journey for passengers."
  },
  {
    WhyChooseheading: "Book Mumbai to Shani Shingnapur Cab with Shreesha Travels",
    WhyChoosedescription: "Get reliable cab booking support, transparent pricing, and comfortable chauffeur-driven vehicles for your spiritual journey from Mumbai to Shani Shingnapur."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Shani Shingnapur cab for temple visit?",
    answer: "Yes, we provide comfortable cab services from Mumbai to Shani Shingnapur for devotees, families, and religious tours."
  },
  {
    question: "Is Mumbai to Shani Shingnapur one-way cab available?",
    answer: "Yes, one-way cab services are available for travellers who need direct transportation to Shani Shingnapur."
  },
  {
    question: "Which vehicles are available for this pilgrimage route?",
    answer: "We offer Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger requirements."
  },
  {
    question: "Can I visit other religious places along with Shani Shingnapur?",
    answer: "Yes, customized routes can include nearby temples and sightseeing locations according to your travel plan."
  },
  {
    question: "Is this cab service suitable for senior citizens?",
    answer: "Yes, comfortable vehicles and experienced drivers make the journey convenient for senior citizens and families."
  },
  {
    question: "Do you provide round-trip Mumbai to Shani Shingnapur taxis?",
    answer: "Yes, round-trip cab packages are available with flexible waiting time and return schedules."
  },
  {
    question: "Can I book a cab from any location in Mumbai?",
    answer: "Yes, pickup can be arranged from airports, railway stations, hotels, residential areas, and other locations across Mumbai."
  },
  {
    question: "How is the Mumbai to Shani Shingnapur cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, waiting time, and selected travel package."
  },
  {
    question: "Are same-day return trips available?",
    answer: "Yes, same-day return options can be arranged depending on your preferred schedule and temple visit duration."
  },
  {
    question: "How can I book Mumbai to Shani Shingnapur Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger count, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Kulkarni",
    feedback: "Our Shani Shingnapur temple visit from Mumbai was arranged perfectly. The car was comfortable, the driver was polite, and the complete journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Deshmukh",
    feedback: "The pilgrimage trip was very convenient with Shreesha Travels. The clean vehicle and professional service made our family journey peaceful and enjoyable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shani Shingnapur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-shani-shingnapur-cab.webp",
  "description":
    "Book Mumbai to Shani Shingnapur Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for temple visits, religious tours, family trips, and outstation journeys from Mumbai to Shani Shingnapur with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-shani-shingnapur-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Mumbai to Shani Shingnapur Cab | Temple Tour Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Shani Shingnapur Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for temple visits, family trips, and Maharashtra religious tours with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Shani Shingnapur Cab, Mumbai to Shani Shingnapur Taxi, Mumbai to Shani Shingnapur Cab Service, Mumbai to Shani Shingnapur Taxi Service, Mumbai to Shani Shingnapur Cab Booking, Mumbai to Shani Shingnapur Car Rental, Mumbai to Shani Shingnapur One Way Cab, Mumbai to Shani Shingnapur Round Trip Taxi, Mumbai Religious Tour Cab, Mumbai Temple Tour Taxi, Shani Shingnapur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoshanishiignapurcab;